module.exports = {
	"price-wrapper": "findify-components--cards--product--price__price-wrapper",
	"priceWrapper": "findify-components--cards--product--price__price-wrapper",
	"simple": "findify-components--cards--product--price__simple",
	"price": "findify-components--cards--product--price__price",
	"compare": "findify-components--cards--product--price__compare",
	"sale-price": "findify-components--cards--product--price__sale-price",
	"salePrice": "findify-components--cards--product--price__sale-price"
};